import { makeActionCreator } from '../../../utilities'
import { OptionsConstants } from './options.constants'

export const setAssessedByOptions = makeActionCreator(OptionsConstants.SET_ASSESSED_BY_OPTIONS, 'assessedByOptions')
export const setDistanceUnitOptions = makeActionCreator(
  OptionsConstants.SET_DISTANCE_UNIT_OPTIONS,
  'distanceUnitOptions'
)
export const setMethodOptions = makeActionCreator(OptionsConstants.SET_METHOD_OPTIONS, 'methodOptions')
export const setSecuredViaOptions = makeActionCreator(OptionsConstants.SET_SECURED_VIA_OPTIONS, 'securedViaOptions')
export const setVerifiedByOptions = makeActionCreator(OptionsConstants.SET_VERIFIED_BY_OPTIONS, 'verifiedByOptions')
export const setVerificationViaOptions = makeActionCreator(
  OptionsConstants.SET_VERIFICATION_VIA_OPTIONS,
  'verificationViaOptions'
)
export const setAirwayPlacementTechniqueOptions = makeActionCreator(
  OptionsConstants.SET_AIRWAY_PLACEMENT_TECHNIQUE_OPTIONS,
  'airwayPlacementTechniqueOptions'
)
export const setRSIProtocolOptions = makeActionCreator(OptionsConstants.SET_RSI_PROTOCOL_OPTIONS, 'rSIProtocolOptions')
export const setMallampatiOptions = makeActionCreator(OptionsConstants.SET_MALLAMPATI_OPTIONS, 'mallampatiOptions')
export const setSellickManeuverOptions = makeActionCreator(
  OptionsConstants.SET_SELLICK_MANEUVER_OPTIONS,
  'sellickManeuverOptions'
)
export const setLaryngoscopicGradeOptions = makeActionCreator(
  OptionsConstants.SET_LARYNGOSCOPIC_GRADE_OPTIONS,
  'laryngoscopicGradeOptions'
)
export const setStyletUsedOptions = makeActionCreator(OptionsConstants.SET_STYLET_USED_OPTIONS, 'styletUsedOptions')
export const setCuffFillOptions = makeActionCreator(OptionsConstants.SET_CUFF_FILL_OPTIONS, 'cuffFillOptions')
export const setLaryngoscopeBladeOptions = makeActionCreator(
  OptionsConstants.SET_LARYNGOSCOPE_BLADE_OPTIONS,
  'laryngoscopeBladeOptions'
)
export const setIndicationsOptions = makeActionCreator(OptionsConstants.SET_INDICATIONS_OPTIONS, 'indicationsOptions')
export const setAirwayComplicationsOptions = makeActionCreator(
  OptionsConstants.SET_AIRWAY_COMPLICATIONS_OPTIONS,
  'airwayComplicationsOptions'
)
export const setProcedureComplicationsOptions = makeActionCreator(
  OptionsConstants.SET_PROCEDURE_COMPLICATIONS_OPTIONS,
  'procedureComplicationsOptions'
)
export const setResponseOptions = makeActionCreator(OptionsConstants.SET_RESPONSE_OPTIONS, 'responseOptions')
export const setChunkedPatientMedicalHistoryOptions = makeActionCreator(
  OptionsConstants.SET_CHUNKED_PATIENT_MEDICAL_HISTORY,
  'chunkedPatientMedicalHistoryOptions'
)
export const setTransformedPatientMedicalHistoryOptions = makeActionCreator(
  OptionsConstants.SET_TRANSFORMED_CHUNKED_PATIENT_MEDICAL_HISTORY,
  'transformedChunkedPatientMedicalHistoryOptions'
)
export const setPatientMedicalHistoryOptions = makeActionCreator(
  OptionsConstants.SET_PATIENT_MEDICAL_HISTORY,
  'medicalHistoryOptions'
)
export const setFullPatientMedicalHistoryOptions = makeActionCreator(
  OptionsConstants.SET_FULL_PATIENT_MEDICAL_HISTORY,
  'medicalHistoryOptionsFullList'
)

export const setObtainedFromOptions = makeActionCreator(
  OptionsConstants.SET_OBTAINED_FROM_OPTIONS,
  'obtainedFromOptions'
)

export const setEmergencyInfoFormOptions = makeActionCreator(
  OptionsConstants.SET_EMERGENCY_INFO_FORM_OPTIONS,
  'emergencyInfoFormOptions'
)

export const setPatientCommonMedicationsOptions = makeActionCreator(
  OptionsConstants.SET_COMMON_MEDICATIONS_OPTIONS,
  'medicationsCommonOptions'
)
export const setPatientMedicationsOptions = makeActionCreator(
  OptionsConstants.SET_MEDICATIONS_OPTIONS,
  'medicationsOptions'
)
export const getPatientMedicationsOptions = makeActionCreator(OptionsConstants.GET_MEDICATIONS_OPTIONS)
export const setActionOptions = makeActionCreator(OptionsConstants.SET_ACTION_OPTIONS, 'actionOptions')

export const setDrainActionOptions = makeActionCreator(OptionsConstants.SET_DRAIN_ACTION_OPTIONS, 'actionOptions')
export const setDrainProcedureOptions = makeActionCreator(
  OptionsConstants.SET_DRAIN_PROCEDURE_OPTIONS,
  'procedureOptions'
)
export const setDrainSizeUnitOptions = makeActionCreator(
  OptionsConstants.SET_DRAIN_SIZE_UNIT_OPTIONS,
  'sizeUnitOptions'
)
export const setDrainSuctionOptions = makeActionCreator(
  OptionsConstants.SET_DRAIN_DRAIN_SUCTION_OPTIONS,
  'drainSuctionOptions'
)
export const setDrainChestSuctionOptions = makeActionCreator(
  OptionsConstants.SET_DRAIN_CHEST_SUCTION_OPTIONS,
  'chestSuctionOptions'
)
export const setDrainFoleyColorOptions = makeActionCreator(
  OptionsConstants.SET_DRAIN_FOLEY_COLOR_OPTIONS,
  'foleyColorOptions'
)
export const setDrainCsfColorOptions = makeActionCreator(
  OptionsConstants.SET_DRAIN_CSF_COLOR_OPTIONS,
  'csfColorOptions'
)
export const setDrainSideOptions = makeActionCreator(OptionsConstants.SET_DRAIN_SIDE_OPTIONS, 'sideOptions')
export const setDrainLocationOptions = makeActionCreator(OptionsConstants.SET_DRAIN_LOCATION_OPTIONS, 'locationOptions')
export const setDrainIntercostalSpaceOptions = makeActionCreator(
  OptionsConstants.SET_DRAIN_INTERCOSTAL_SPACE_OPTIONS,
  'intercostalSpaceOptions'
)
export const setIleostomyColostomyOptions = makeActionCreator(
  OptionsConstants.SET_ILEOSTOMY_COLOSTOMY_OPTIONS,
  'ileostomyColostomyOptions'
)

export const setDefibTypeOptions = makeActionCreator(OptionsConstants.SET_DEFIB_TYPE_OPTIONS, 'defibTypeOptions')
export const setLeadChangeOptions = makeActionCreator(OptionsConstants.SET_LEAD_CHANGE_OPTIONS, 'leadChangeOptions')
export const setTypeOptions = makeActionCreator(OptionsConstants.SET_TYPE_OPTIONS, 'typeOptions')
export const setVerbalResponseOptions = makeActionCreator(
  OptionsConstants.SET_VERBAL_RESPONSE_OPTIONS,
  'verbalResponseOptions'
)
export const setEyeOpeningResponseOptions = makeActionCreator(
  OptionsConstants.SET_EYE_OPENING_RESPONSE_OPTIONS,
  'eyeOpeningResponseOptions'
)
export const setProtocolOptions = makeActionCreator(OptionsConstants.SET_PROTOCOL_OPTIONS, 'protocolOptions')
export const setBpMethodOptions = makeActionCreator(
  OptionsConstants.SET_BLOOD_PRESSURE_METHOD_OPTIONS,
  'bloodPressureMethodOptions'
)
export const setMotorResponseOptions = makeActionCreator(
  OptionsConstants.SET_MOTOR_RESPONSE_OPTIONS,
  'motorResponseOptions'
)
export const setHeartRateMethodsOptions = makeActionCreator(
  OptionsConstants.SET_HEART_RATE_METHODS_OPTIONS,
  'heartRateMethodOptions'
)
export const setNeuroLocOptions = makeActionCreator(OptionsConstants.SET_NEUROLOC_OPTIONS, 'neuroLocOptions')
export const setStrokeScaleOptions = makeActionCreator(OptionsConstants.SET_STROKE_SCALE_OPTIONS, 'strokeScaleOptions')
export const setStrokeScaleScoreOptions = makeActionCreator(
  OptionsConstants.SET_STROKE_SCALE_SCORE_OPTIONS,
  'strokeScaleScoreOptions'
)
export const setRespirationRateEffortOptions = makeActionCreator(
  OptionsConstants.SET_RESPIRATION_RATE_EFFORT_OPTIONS,
  'respirationRateEffortOptions'
)
export const setPainScaleOptions = makeActionCreator(OptionsConstants.SET_PAIN_SCALE_OPTIONS, 'painScaleOptions')
export const setWithdrawalScaleOptions = makeActionCreator(
  OptionsConstants.SET_WITHDRAWAL_SCALE_OPTIONS,
  'withdrawalScaleOptions'
)
export const setWithdrawalScaleTypeOptions = makeActionCreator(
  OptionsConstants.SET_WITHDRAWAL_SCALE_TYPE_OPTIONS,
  'withdrawScaleTypeOptions'
)
export const setPainQualityOnsetUnitOptions = makeActionCreator(
  OptionsConstants.SET_PAIN_QUALITY_ONSET_UNIT_OPTIONS,
  'painQualityOnsetUnitOptions'
)
export const setPainQualityFieldOptions = makeActionCreator(
  OptionsConstants.SET_PAIN_QUALITY_FIELD_OPTIONS,
  'painQualityFieldOptions'
)
export const setSedationScaleOptions = makeActionCreator(
  OptionsConstants.SET_SEDATION_SCALE_OPTIONS,
  'sedationScaleOptions'
)
export const setAdditionalPainScaleOptions = makeActionCreator(
  OptionsConstants.SET_ADDITIONAL_PAIN_SCALE_OPTIONS,
  'additionalPainScaleOptions'
)

export const setTempMethodOptions = makeActionCreator(
  OptionsConstants.SET_TEMPERATURE_METHOD_OPTIONS,
  'temperatureMethodOptions'
)
export const setEtco2TypeOptions = makeActionCreator(OptionsConstants.SET_ETCO2_TYPE_OPTIONS, 'etco2TypeOptions')
export const setRhythmOptions = makeActionCreator(OptionsConstants.SET_RHYTHM_OPTIONS, 'rhythmOptions')
export const setRegularityOptions = makeActionCreator(OptionsConstants.SET_REGULARITY_OPTIONS, 'regularityOptions')
export const setEcgTypeOptions = makeActionCreator(OptionsConstants.SET_ECG_TYPE_OPTIONS, 'ecgTypeOptions')
export const setEcgTypeMethodOptions = makeActionCreator(
  OptionsConstants.SET_ECG_TYPE_METHOD_OPTIONS,
  'ecgTypeMethodOptions'
)
export const setVitalsAssessedByOptions = makeActionCreator(
  OptionsConstants.SET_VITALS_ASSESSED_BY_OPTIONS,
  'assessedByOptions'
)
export const setPerformedByOptions = makeActionCreator(OptionsConstants.SET_PERFORMED_BY_OPTIONS, 'performedByOptions')
export const setDoseUnitOptions = makeActionCreator(OptionsConstants.SET_DOSE_UNIT_OPTIONS, 'doseUnitOptions')
export const setRateUnitOptions = makeActionCreator(OptionsConstants.SET_RATE_UNIT_OPTIONS, 'rateUnitOptions')
export const setFrequencyOptions = makeActionCreator(OptionsConstants.SET_FREQUENCY_OPTIONS, 'frequencyOptions')
export const setResponseValueOptions = makeActionCreator(OptionsConstants.SET_RESPONSE_VALUE_OPTIONS, 'responseOptions')
export const setComplicationsOptions = makeActionCreator(
  OptionsConstants.SET_COMPLICATIONS_OPTIONS,
  'complicationsOptions',
  'medicationAdministered'
)
export const setAuthorizationOptions = makeActionCreator(
  OptionsConstants.SET_AUTHORIZATION_OPTIONS,
  'authorizationOptions'
)
export const setPnMedicationMedicationOptions = makeActionCreator(
  OptionsConstants.SET_PN_MEDICATION_MEDICATION_OPTIONS,
  'medicationOptions'
)
export const setMedicationsOptions = makeActionCreator(OptionsConstants.SET_MEDICATION_OPTIONS, 'medicationsOptions')
export const setMedicationAdministeredRouteOptions = makeActionCreator(
  OptionsConstants.SET_MEDICATION_ADMINISTERED_ROUTE_OPTIONS,
  'routeOptions'
)
export const setRouteOptions = makeActionCreator(OptionsConstants.SET_ROUTE_OPTIONS, 'routeOptions')
export const setPatientAllergiesOptions = makeActionCreator(
  OptionsConstants.SET_PATIENT_ALLERGIES_OPTIONS,
  'patientAllergies'
)
export const setPatientAllergiesFoodEnvironmentButtonWallOptions = makeActionCreator(
  OptionsConstants.SET_PATIENT_ALLERGIES_FOOD_ENVIRONMENT_BUTTON_WALL_OPTIONS,
  'foodEnvironmentalAllergiesOptions'
)
export const setPatientAllergiesMedicationButtonWallOptions = makeActionCreator(
  OptionsConstants.SET_PATIENT_ALLERGIES_MEDICATION_BUTTON_WALL_OPTIONS,
  'medicationsAllergiesOptions'
)
export const setBaseOptions = makeActionCreator(OptionsConstants.SET_BASE_OPTIONS, 'baseOptions')
export const setUnitOptions = makeActionCreator(OptionsConstants.SET_UNIT_OPTIONS, 'unitOptions')
export const setStaffingLevelOptions = makeActionCreator(
  OptionsConstants.SET_STAFFING_LEVEL_OPTIONS,
  'staffingLevelOptions'
)
export const setShiftOptions = makeActionCreator(OptionsConstants.SET_SHIFT_OPTIONS, 'shiftOptions')
export const setRegistrationTailOptions = makeActionCreator(
  OptionsConstants.SET_REGISTRATION_TAIL_OPTIONS,
  'registrationTailOptions'
)
export const setDispatchPriorityOptions = makeActionCreator(
  OptionsConstants.SET_DISPATCH_PRIORITY_OPTIONS,
  'dispatchPriorityOptions'
)
export const setEmdPerformedOptions = makeActionCreator(
  OptionsConstants.SET_EMD_PERFORMED_OPTIONS,
  'emdPerformedOptions'
)
export const setTypeofServiceOptions = makeActionCreator(
  OptionsConstants.SET_TYPE_OF_SERVICE_OPTIONS,
  'typeofServiceOptions'
)
export const setStandByPurposeOptions = makeActionCreator(
  OptionsConstants.SET_STANDBY_PURPOSE_OPTIONS,
  'standByPurposeOptions'
)
export const setPatientCategoryOptions = makeActionCreator(
  OptionsConstants.SET_PATIENT_CATEGORY_OPTIONS,
  'patientCategoryOptions'
)
export const setDispatchedAsOptions = makeActionCreator(
  OptionsConstants.SET_DISPATCHED_AS_OPTIONS,
  'dispatchedAsOptions'
)
export const setDispositionOptions = makeActionCreator(OptionsConstants.SET_DISPOSITION_OPTIONS, 'dispositionOptions')
export const setUnitDispositionOptions = makeActionCreator(
  OptionsConstants.SET_UNIT_DISPOSITION_OPTIONS,
  'unitDispositionOptions'
)
export const setPatientEvaluationOptions = makeActionCreator(
  OptionsConstants.SET_PATIENT_EVALUATION_OPTIONS,
  'patientEvaluationOptions'
)
export const setCrewDispositionOptions = makeActionCreator(
  OptionsConstants.SET_CREW_DISPOSITION_OPTIONS,
  'crewDispositionOptions'
)
export const setTransportDispositionOptions = makeActionCreator(
  OptionsConstants.SET_TRANSPORT_DISPOSITION_OPTIONS,
  'transportDispositionOptions'
)
export const setRefusalReleaseReasonOptions = makeActionCreator(
  OptionsConstants.SET_REFUSAL_RELEASE_REASON_OPTIONS,
  'refusalReleaseReasonOptions'
)

export const setAmbulanceTransportCodeOptions = makeActionCreator(
  OptionsConstants.SET_AMBULANCE_TRANSPORT_CODE_OPTIONS,
  'ambulanceTransportCodeOptions'
)
export const setScheduledOptions = makeActionCreator(OptionsConstants.SET_SCHEDULED_OPTIONS, 'scheduledOptions')
export const setMassCasualtyOptions = makeActionCreator(
  OptionsConstants.SET_MASS_CASUALTY_OPTIONS,
  'massCasualtyOptions'
)
export const setVehicleGridOptions = makeActionCreator(OptionsConstants.SET_VEHICLE_GRID_OPTIONS, 'vehicleGridOptions')
export const setEmsVehicleOptions = makeActionCreator(OptionsConstants.SET_EMS_VEHICLE_OPTIONS, 'emsVehicleOptions')
export const setEmsRegTailNumberOptions = makeActionCreator(
  OptionsConstants.SET_EMS_REG_TAIL_NUMBER_OPTIONS,
  'emsRegTailNumberOptions'
)

export const setBloodTypeOptions = makeActionCreator(OptionsConstants.SET_BLOOD_TYPE_OPTIONS, 'bloodTypeOptions')
export const setCountryOptions = makeActionCreator(OptionsConstants.SET_COUNTRY_OPTIONS, 'countryOptions')
export const setDLStateOptions = makeActionCreator(OptionsConstants.SET_DL_STATE_OPTIONS, 'dLStateOptions')
export const setEmailTypeOptions = makeActionCreator(OptionsConstants.SET_EMAIL_TYPE_OPTIONS, 'emailTypeOptions')
export const setSexOptions = makeActionCreator(OptionsConstants.SET_SEX_OPTIONS, 'sexOptions')
export const setGenderOptions = makeActionCreator(OptionsConstants.SET_GENDER_OPTIONS, 'genderOptions')
export const setPhoneTypeOptions = makeActionCreator(OptionsConstants.SET_PHONE_TYPE_OPTIONS, 'phoneTypeOptions')
export const setRaceOptions = makeActionCreator(OptionsConstants.SET_RACE_OPTIONS, 'raceOptions')
export const setStateOptions = makeActionCreator(OptionsConstants.SET_STATE_OPTIONS, 'stateOptions')
export const setSuffixOptions = makeActionCreator(OptionsConstants.SET_SUFFIX_OPTIONS, 'suffixOptions')
export const setTriageColorOptions = makeActionCreator(OptionsConstants.SET_TRIAGE_COLOR_OPTIONS, 'triageColorOptions')
export const setWeightOptions = makeActionCreator(OptionsConstants.SET_WEIGHT_OPTIONS, 'weightUnitOptions')
export const setHeightOptions = makeActionCreator(OptionsConstants.SET_HEIGHT_OPTIONS, 'heightUnitOptions')
export const setAgeOptions = makeActionCreator(OptionsConstants.SET_AGE_OPTIONS, 'ageUnitOptions')
export const setGuarantorsAgeOptions = makeActionCreator(OptionsConstants.SET_GUARANTORS_AGE_OPTIONS, 'ageUnits')
export const setInterfacilityTransferOptions = makeActionCreator(
  OptionsConstants.SET_INTERFACILITY_TRANSFER_OPTIONS,
  'interfacilityTransferOptions'
)

export const setChunkedPatientAllergiesOptions = makeActionCreator(
  OptionsConstants.SET_CHUNKED_PATIENT_ALLERGIES,
  'chunkedPatientAllergyOptions'
)
export const setTransformedPatientAllergiesOptions = makeActionCreator(
  OptionsConstants.SET_TRANSFORMED_CHUNKED_PATIENT_ALLERGIES,
  'transformedChunkedPatientAllergyOptions'
)

export const setLocationTypeOptions = makeActionCreator(
  OptionsConstants.SET_LOCATION_TYPE_OPTIONS,
  'locationTypeOptions'
)
export const setOtherTypeOptions = makeActionCreator(OptionsConstants.SET_OTHER_TYPE_OPTIONS, 'otherTypeOptions')
export const setResponseModeOptions = makeActionCreator(
  OptionsConstants.SET_RESPONSE_MODE_OPTIONS,
  'responseModeOptions'
)
export const setResponseModeCustomOptions = makeActionCreator(
  OptionsConstants.SET_RESPONSE_MODE_CUSTOM_OPTIONS,
  'responseModeCustomOptions'
)
export const setAirwayActionOptions = makeActionCreator(OptionsConstants.SET_AIRWAY_ACTION_OPTIONS, 'actionOptions')
export const setAirwayViaOptions = makeActionCreator(OptionsConstants.SET_AIRWAY_VIA_OPTIONS, 'viaOptions')
export const setAirwayVerificationMethodOptions = makeActionCreator(
  OptionsConstants.SET_AIRWAY_VERIFICATION_METHOD_OPTIONS,
  'verificationMethodOptions'
)
export const setAirwayCompOptions = makeActionCreator(
  OptionsConstants.SET_AIRWAY_COMP_OPTIONS,
  'airwayComplicationsOptions'
)
export const setAirwayTempertureUnitOptions = makeActionCreator(
  OptionsConstants.SET_AIRWAY_TEMPERTURE_UNIT_OPTIONS,
  'airTemperatureUnitOptions'
)
export const setChildbirthOBActionOptions = makeActionCreator(
  OptionsConstants.SET_CHILDBIRTHOB_ACTION_OPTIONS,
  'actionOptions'
)
export const setVariabilityOptions = makeActionCreator(OptionsConstants.SET_VARIABILITY_OPTIONS, 'variabilityOptions')
export const setAccelerationsOptions = makeActionCreator(
  OptionsConstants.SET_ACCELERATIONS_OPTIONS,
  'accelerationsOptions'
)
export const setDecelerationOptions = makeActionCreator(
  OptionsConstants.SET_DECELERATION_OPTIONS,
  'decelerationOptions'
)
export const setUcStrengthOptions = makeActionCreator(OptionsConstants.SET_UC_STRENGTH_OPTIONS, 'ucStrengthOptions')
export const setDtrOptions = makeActionCreator(OptionsConstants.SET_DTR_OPTIONS, 'dtrOptions')
export const setIvSiteOptions = makeActionCreator(OptionsConstants.SET_IV_SITE_OPTIONS, 'siteOptions')
export const setIvTypeOptions = makeActionCreator(OptionsConstants.SET_IV_TYPE_OPTIONS, 'typeOptions')
export const setImmobilizationAssessmentOptions = makeActionCreator(
  OptionsConstants.SET_IMMOBILIZATION_ASSESSMENT_OPTIONS,
  'assessmentOptions'
)
export const setImmobilizationSiteOptions = makeActionCreator(
  OptionsConstants.SET_IMMOBILIZATION_SITE_OPTIONS,
  'siteOptions'
)
export const setImmobilizationDevicesUsedOptions = makeActionCreator(
  OptionsConstants.SET_IMMOBILIZATION_DEVICES_USED_OPTIONS,
  'devicesUsedOptions'
)
export const setImmobilizationOptionOptions = makeActionCreator(
  OptionsConstants.SET_IMMOBILIZATION_OPTION_OPTIONS,
  'optionOptions'
)
export const setPhysicianOptions = makeActionCreator(OptionsConstants.SET_PHYSICIAN_OPTIONS, 'physicianOptions')
export const setMedicalConsultMethodOptions = makeActionCreator(
  OptionsConstants.SET_MEDICAL_CONSULT_METHOD_OPTIONS,
  'methodOptions'
)
export const setMedicalConsultFacilityOptions = makeActionCreator(
  OptionsConstants.SET_MEDICAL_CONSULT_FACILITY_OPTIONS,
  'facilityOptions'
)
export const setRescueTypesOptions = makeActionCreator(OptionsConstants.SET_RESCUE_TYPES_OPTIONS, 'typesOptions')
export const setHydraulicsOptions = makeActionCreator(OptionsConstants.SET_HYDRAULICS_OPTIONS, 'hydraulicsOptions')
export const setToolsOptions = makeActionCreator(OptionsConstants.SET_TOOLS_OPTIONS, 'toolsOptions')
export const setRehabOptions = makeActionCreator(OptionsConstants.SET_REHAB_OPTIONS, 'rehabOptions')
export const setActivationsOptions = makeActionCreator(OptionsConstants.SET_ACTIVATIONS_OPTIONS, 'activationsOptions')
export const setModeOptions = makeActionCreator(OptionsConstants.SET_MODE_OPTIONS, 'modeOptions')
export const setBreathTypeOptions = makeActionCreator(OptionsConstants.SET_BREATH_TYPE_OPTIONS, 'breathTypeOptions')
export const setVentilatorActionsOptions = makeActionCreator(
  OptionsConstants.SET_VENTILATOR_ACTIONS_OPTIONS,
  'actionOptions'
)
export const setVentilatorTempertureUnitOptions = makeActionCreator(
  OptionsConstants.SET_VENTILATOR_TEMPERTURE_UNIT_OPTIONS,
  'airTemperatureUnitOptions'
)
export const setPrevVentilatorState = makeActionCreator(
  OptionsConstants.SET_VENTILATOR_PREVSTATE,
  'previousVentilatorState'
)
export const setWoundCareActionsOptions = makeActionCreator(
  OptionsConstants.SET_WOUND_CARE_ACTIONS_OPTIONS,
  'actionsOptions'
)
export const setWoundCareSiteOptions = makeActionCreator(OptionsConstants.SET_WOUND_CARE_SITE_OPTIONS, 'siteOptions')
export const setHospitalNotifyMethodOptions = makeActionCreator(
  OptionsConstants.SET_HOSPITAL_NOTIFY_METHOD_OPTIONS,
  'methodOptions'
)
export const setHospitalNotifyAlertOptions = makeActionCreator(
  OptionsConstants.SET_HOSPITAL_NOTIFY_ALERT_OPTIONS,
  'alertOptions'
)
export const setPotentialRegistryOptions = makeActionCreator(
  OptionsConstants.SET_POTENTIAL_REGISTRY_OPTIONS,
  'potentialRegistryOptions'
)
export const setSectionOptions = makeActionCreator(OptionsConstants.SET_SECTION_OPTIONS, 'sectionOptions')
export const setSignatureTypeOptions = makeActionCreator(
  OptionsConstants.SET_SIGNATURE_TYPE_OPTIONS,
  'signatureTypeOptions'
)
export const setSignatureSecTwoPatientUnableToSignOptions = makeActionCreator(
  OptionsConstants.SET_SIGNATURE_SEC_TWO_PATIENT_UNABLE_TO_SIGN_OPTIONS,
  'signatureSecTwoPatientUnableToSignOptions'
)
export const setSectionOneTypes = makeActionCreator(OptionsConstants.SET_SECTION_ONE_TYPES, 'sectionOneSignatureTypes')
export const setSectionTwoTypes = makeActionCreator(OptionsConstants.SET_SECTION_TWO_TYPES, 'sectionTwoSignatureTypes')
export const setSectionThreeTypes = makeActionCreator(
  OptionsConstants.SET_SECTION_THREE_TYPES,
  'sectionThreeSignatureTypes'
)
export const setSelectedCrewMembers = makeActionCreator(
  OptionsConstants.SET_SELECTED_CREW_MEMBERS,
  'selectedCrewMembers'
)
export const setFormText = makeActionCreator(
  OptionsConstants.SET_FORM_TEXT,
  'headerText',
  'acknowledgmentText',
  'sectionIText',
  'sectionIIText',
  'sectionIIIText'
)
export const resetFormText = makeActionCreator(OptionsConstants.RESET_FORM_TEXT)
export const setNihPositiveStrokeScaleQuestionAnswers = makeActionCreator(
  OptionsConstants.SET_NIH_POSITIVE_STROKE_SCALE_QUESTION_ANSWERS,
  'nihPositiveStrokeScaleQuestionAnswers'
)
export const setRaceStrokeScaleQuestionAnswers = makeActionCreator(
  OptionsConstants.SET_RACE_STROKE_SCALE_QUESTION_ANSWERS,
  'raceStrokeScaleQuestionAnswers'
)
export const setServiceModules = makeActionCreator(OptionsConstants.SET_SERVICE_MODULES, 'serviceModules')
export const setMedicationsAllergies = makeActionCreator(
  OptionsConstants.SET_MEDICATIONS_ALLERGIES,
  'medicationsAllergiesOptions'
)
export const setFoodEnvironmentalAllergies = makeActionCreator(
  OptionsConstants.SET_FOOD_ENVIRONMENTAL_ALLERGIES,
  'foodEnvironmentalAllergiesOptions'
)
export const setCadRecords = makeActionCreator(OptionsConstants.SET_CAD_RECORDS, 'data')

export const setPhoneNumber = makeActionCreator(OptionsConstants.SET_PHONE, 'number', 'phoneDetail')
export const setPhoneType = makeActionCreator(OptionsConstants.SET_PHONE_TYPE, 'phoneType', 'phoneDetail')
export const deletePhone = makeActionCreator(OptionsConstants.DELETE_PHONE, 'phoneDetail')
export const setEmail = makeActionCreator(OptionsConstants.SET_EMAIL, 'email', 'emailDetail')
export const setEmailType = makeActionCreator(OptionsConstants.SET_EMAIL_TYPE, 'emailType', 'emailDetail')
export const deleteEmail = makeActionCreator(OptionsConstants.DELETE_EMAIL, 'emailDetail')
export const setEmailDetail = makeActionCreator(OptionsConstants.SET_EMAIL_DETAIL, 'emailDetail')
export const setHospitalUnitOptions = makeActionCreator(
  OptionsConstants.SET_HOSPITAL_UNIT_OPTIONS,
  'hospitalUnitOptions'
)
export const setHospitalNameOptions = makeActionCreator(
  OptionsConstants.SET_HOSPITAL_NAME_OPTIONS,
  'hospitalNameOptions'
)
export const setEMSNameOptions = makeActionCreator(OptionsConstants.SET_EMS_NAME_OPTIONS, 'emsNameOptions')
export const setSceneGridOptions = makeActionCreator(OptionsConstants.SET_SCENE_GRID_OPTIONS, 'sceneGridOptions')
export const setModeDescriptorsOptions = makeActionCreator(
  OptionsConstants.SET_MODE_DESCRIPTORS_OPTIONS,
  'modeDescriptorsOptions'
)
export const setPatientActivityOptions = makeActionCreator(
  OptionsConstants.SET_PATIENT_ACTIVITY_OPTIONS,
  'patientActivityOptions'
)
export const setInitialPatientAcuityOptions = makeActionCreator(
  OptionsConstants.SET_INITIAL_PATIENT_ACUITY_OPTIONS,
  'initialPatientAcuityOptions'
)
export const setReasonForEncounterOptions = makeActionCreator(
  OptionsConstants.SET_REASON_FOR_ENCOUNTER_OPTIONS,
  'reasonForEncounterOptions'
)
export const setDrugsAndAlcoholOptions = makeActionCreator(
  OptionsConstants.SET_DRUGS_AND_ALCOHOL_OPTIONS,
  'drugsAndAlcoholOptions'
)
export const setDrugsAndAlcoholIndicatorsOptions = makeActionCreator(
  OptionsConstants.SET_DRUGS_AND_ALCOHOL_INDICATORS_OPTIONS,
  'drugsAndAlcoholIndicatorsOptions'
)
export const setArrestPresentOptions = makeActionCreator(OptionsConstants.SET_ARREST_PRESENT, 'arrestPresentOptions')
export const setWhoWitnessedOptions = makeActionCreator(OptionsConstants.SET_WHO_WITNESSED, 'whoWitnessedOptions')
export const setEtiologyOptions = makeActionCreator(OptionsConstants.SET_ETIOLOGY, 'etiologyOptions')
export const setTherapeuticHypothermia = makeActionCreator(
  OptionsConstants.SET_THERAPEUTIC_HYPOTHERMIA,
  'therapeuticHypothermiaOptions'
)
export const setInitialRhythm = makeActionCreator(OptionsConstants.SET_INITIAL_RHYTHM, 'initialRhythmOptions')
export const setCprPriorEmsArrival = makeActionCreator(
  OptionsConstants.SET_CPR_PRIOR_EMS_ARRIVAL,
  'cprPriorEmsArrivalOptions'
)
export const setFirstCpr = makeActionCreator(OptionsConstants.SET_FIRST_CPR, 'firstCprOptions')
export const setCprByOptions = makeActionCreator(OptionsConstants.SET_CPR_BY, 'cprByOptions')
export const setCprTypeOptions = makeActionCreator(OptionsConstants.SET_CPR_TYPE, 'cprTypeOptions')
export const setResuscitationOptions = makeActionCreator(OptionsConstants.SET_RESUSCITATION, 'resuscitationOptions')
export const setAedUseOptions = makeActionCreator(OptionsConstants.SET_AED_USE, 'aedUseOptions')
export const setFirstAedByOptions = makeActionCreator(OptionsConstants.SET_FIRST_AED_BY, 'firstAedByOptions')
export const setAedByOptions = makeActionCreator(OptionsConstants.SET_AED_BY, 'aedByOptions')
export const setDefibType1Options = makeActionCreator(OptionsConstants.SET_DEFIB_TYPE, 'defibTypeOptions')
export const setDefibByOptions = makeActionCreator(OptionsConstants.SET_DEFIB_BY, 'defibByOptions')
export const setDiscReasonOptions = makeActionCreator(OptionsConstants.SET_DISC_REASON, 'discReasonOptions')
export const setReturnCircualtionOptions = makeActionCreator(
  OptionsConstants.SET_RETURN_CIRCULATION,
  'returnCirculationOptions'
)
export const setDestRhythmOptions = makeActionCreator(OptionsConstants.SET_DEST_RHYTHM, 'destRhythmOptions')
export const setArrestResultOptions = makeActionCreator(OptionsConstants.SET_ARREST_RESULT, 'arrestResultOptions')
export const setIntentionalOptions = makeActionCreator(OptionsConstants.SET_INTENTIONAL_OPTIONS, 'intentionalOptions')
export const setTraumatriageCriteriaHighRiskOptions = makeActionCreator(
  OptionsConstants.SET_TRAUMA_TRIAGE_CRITERIA_HIGH_RISK_OPTIONS,
  'traumaTriageCriteriaHighRiskOptions'
)
export const setTraumaTriageCriteriaModerateRiskOptions = makeActionCreator(
  OptionsConstants.SET_TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK_OPTIONS,
  'traumaTriageCriteriaModerateRiskOptions'
)
export const setInjurycauseOptions = makeActionCreator(OptionsConstants.SET_INJURY_CAUSE_OPTIONS, 'injurycauseOptions')
export const setMechanismOptions = makeActionCreator(OptionsConstants.SET_MECHANISM_OPTIONS, 'mechanismOptions')
export const setSafetyEquipmentOptions = makeActionCreator(
  OptionsConstants.SET_SAFETY_EQUIPMENT_OPTIONS,
  'safetyEquipmentOptions'
)
export const setFallsurfaceOptions = makeActionCreator(OptionsConstants.SET_FALL_SURFACE_OPTIONS, 'fallsurfaceOptions')
export const setLandedonOptions = makeActionCreator(OptionsConstants.SET_LANDED_ON_OPTIONS, 'landedonOptions')
export const setWorkrelatedOptions = makeActionCreator(OptionsConstants.SET_WORK_RELATED_OPTIONS, 'workrelatedOptions')
export const setCCDurationUnitsOptions = makeActionCreator(
  OptionsConstants.SET_CC_DURATION_UNITS_OPTIONS,
  'ccDurationUnitsOptions'
)
export const setSCDurationUnitsOptions = makeActionCreator(
  OptionsConstants.SET_SC_DURATION_UNITS_OPTIONS,
  'scDurationUnitsOptions'
)
export const setOCDurationUnitsOptions = makeActionCreator(
  OptionsConstants.SET_OC_DURATION_UNITS_OPTIONS,
  'ocDurationUnitsOptions'
)

export const resetCadRecords = makeActionCreator(OptionsConstants.RESET_CAD_RECORDS)
export const resetPatientAllergiesOptions = makeActionCreator(OptionsConstants.RESET_PATIENT_ALLERGIES_OPTIONS)

export const setDestinationBasisOptions = makeActionCreator(
  OptionsConstants.SET_DESTINATION_BASIS_OPTIONS,
  'destinationBasisOptions'
)

export const setDestinationModeDescriptorsOptions = makeActionCreator(
  OptionsConstants.SET_DESTINATION_MODE_DESCRIPTORS_OPTIONS,
  'modeDescriptorsOptions'
)
export const setDestinationTransportModeOptions = makeActionCreator(
  OptionsConstants.SET_DESTINATION_TRANSPORT_MODE_OPTIONS,
  'transportModeOptions'
)
export const setDestinationTransportModeCustomOptions = makeActionCreator(
  OptionsConstants.SET_DESTINATION_TRANSPORT_MODE_CUSTOM_OPTIONS,
  'transportModeCustomOptions'
)
export const setCapabilitiesOptions = makeActionCreator(OptionsConstants.SET_CAPABILITIES_OPTIONS, 'capabilities')
export const setTimeZoneOptions = makeActionCreator(OptionsConstants.SET_TIME_ZONE_OPTIONS, 'timeZoneOptions')
export const setDestinationHospitalOptions = makeActionCreator(
  OptionsConstants.SET_DESTINATION_HOSPITAL_OPTIONS,
  'hospitalOptions'
)
export const setDestinationEMSOptions = makeActionCreator(OptionsConstants.SET_DESTINATION_EMS_OPTIONS, 'emsOptions')
export const setPriorityOptions = makeActionCreator(OptionsConstants.SET_PRIORITY_OPTIONS, 'priorityOptions')
export const setInsuredOptions = makeActionCreator(OptionsConstants.SET_INSURED_OPTIONS, 'insuredOptions')
export const resetInsuredOptions = makeActionCreator(OptionsConstants.RESET_INSURED_OPTIONS, 'insuredOptions')
export const setRelationshipOptions = makeActionCreator(
  OptionsConstants.SET_RELATIONSHIP_OPTIONS,
  'relationshipOptions'
)

export const setConsentFormSignedOption = makeActionCreator(
  OptionsConstants.SET_CONSENT_FORM_SIGNED_OPTIONS,
  'consentFormSignedOptions'
)
export const setNppFormOptions = makeActionCreator(OptionsConstants.SET_NPP_FORM_OPTIONS, 'nppFormOptions')
export const setMedicalNecessitySignedOption = makeActionCreator(
  OptionsConstants.SET_MEDICAL_NECESSITY_SIGNED_OPTIONS,
  'medicalNecessitySignedOptions'
)
export const setPcsReasonOptions = makeActionCreator(OptionsConstants.SET_PCS_REASON_OPTIONS, 'pcsReasonOptions')

export const setPcsProviderTypeOptions = makeActionCreator(
  OptionsConstants.SET_PCS_PROVIDER_TYPE_OPTIONS,
  'pcsProviderTypeOptions'
)

export const setCmsConditionCodeOptions = makeActionCreator(
  OptionsConstants.SET_CMS_CONDITION_CODE_OPTIONS,
  'cmsConditionCodeOptions'
)
export const setFilteredCmsConditionCodeOptions = makeActionCreator(
  OptionsConstants.SET_FILTER_CMS_CONDITION_CODE_OPTIONS,
  'filteredCmsConditionCodeOptions'
)
export const setConditionCodeModifierOptions = makeActionCreator(
  OptionsConstants.SET_CONDITION_CODE_MODIFIER_OPTIONS,
  'conditionCodeModifierOptions'
)

export const setCmsTransportReasonOptions = makeActionCreator(
  OptionsConstants.SET_CMS_TRANSPORT_REASON_OPTIONS,
  'cmsTransportReasonOptions'
)

export const setAmbulanceConditionIndicatorOptions = makeActionCreator(
  OptionsConstants.SET_AMBULANCE_CONDITION_INDICATOR_OPTIONS,
  'ambulanceConditionIndicatorOptions'
)

export const setPrimaryPaymentMethodOptions = makeActionCreator(
  OptionsConstants.SET_PRIMARY_PAYMENT_METHOD_OPTIONS,
  'primaryMethodOfPaymentOptions'
)
export const setX12PayerTypeOptions = makeActionCreator(
  OptionsConstants.SET_X12_PAYER_TYPE_OPTIONS,
  'x12PayerTypeOptions'
)
export const setPriorAuthorizationPayerOptions = makeActionCreator(
  OptionsConstants.SET_PRIOR_AUTHORIZATION_PAYER_OPTIONS,
  'priorAuthorizationPayerOptions'
)
export const setPatientMedicalHistoryIcdNemsisBasicOptions = makeActionCreator(
  OptionsConstants.SET_PATIENT_MEDICAL_HISTORY_ICD_NEMSIS_BASIC,
  'medicalHistoryIcdNemsisBasicOptions'
)
export const setFullPatientMedicalHistoryIcdNemsisBasicOptions = makeActionCreator(
  OptionsConstants.SET_FULL_PATIENT_MEDICAL_HISTORY_ICD_NEMSIS_BASIC,
  'medicalHistoryIcdNemsisBasicOptionsFullList'
)
export const setCameraAttachmentsCategoryOptions = makeActionCreator(
  OptionsConstants.SET_CAMERA_ATTACHMENTS_CATEGORY_OPTIONS,
  'categoryOptions'
)
export const setCutomSignatureOptions = makeActionCreator(
  OptionsConstants.SET_CUSTOM_SIGNATURE_OPTIONS,
  'customSignatureOptions'
)
export const setCutomSignatureTypeOptions = makeActionCreator(
  OptionsConstants.SET_CUSTOM_SIGNATURE_TYPE_OPTIONS,
  'customSignatureTypeOptions'
)
export const setSectionTwoAuthorizedRepresentativeOptions = makeActionCreator(
  OptionsConstants.SET_SECTION_TWO_AUTHORIZED_REPRESENTATIVE_OPTIONS,
  'sectionTwoAuthorizedRepresentativeOptions'
)
export const setCutomSignatureTranformedOptions = makeActionCreator(
  OptionsConstants.SET_CUSTOM_SIGNATURE_TRANSFORMED_OPTIONS,
  'customSignatureTranformedOptions'
)
export const setDispatchFactorsOptions = makeActionCreator(
  OptionsConstants.SET_DISPATCH_FACTORS_OPTIONS,
  'dispatchFactorsOptions'
)
export const setSceneFactorsOptions = makeActionCreator(
  OptionsConstants.SET_SCENE_FACTORS_OPTIONS,
  'sceneFactorsOptions'
)
export const setResponseFactorsOptions = makeActionCreator(
  OptionsConstants.SET_RESPONSE_FACTORS_OPTIONS,
  'responseFactorsOptions'
)
export const setTransportFactorsOptions = makeActionCreator(
  OptionsConstants.SET_TRANSPORT_FACTORS_OPTIONS,
  'transportFactorsOptions'
)
export const setTurnAroundFactorsOptions = makeActionCreator(
  OptionsConstants.SET_TURN_AROUND_FACTORS_OPTIONS,
  'turnAroundFactorsOptions'
)
export const setFactorsOptions = makeActionCreator(OptionsConstants.SET_FACTORS_OPTIONS, 'factorsOptions')
export const setPacingModeOptions = makeActionCreator(OptionsConstants.SET_PACING_MODE_OPTIONS, 'pacingModeOptions')
export const setCompressionRateOptions = makeActionCreator(
  OptionsConstants.SET_COMPRESSION_RATE_OPTIONS,
  'compressionRateOptions'
)
export const setLocationOptions = makeActionCreator(OptionsConstants.SET_LOCATION_OPTIONS, 'locationOptions')
export const setImagingUltrasoundLocationOptions = makeActionCreator(
  OptionsConstants.SET_IMAGING_ULTRASOUND_LOCATION_OPTIONS,
  'imagingUltrasoundLocationOptions'
)
export const setDnrOptions = makeActionCreator(OptionsConstants.SET_DNR_OPTIONS, 'dnrOptions')
export const setBarriersToCareOptions = makeActionCreator(
  OptionsConstants.SET_BARRIERS_TO_CARE_OPTIONS,
  'barriersToCareOptions'
)
export const setPreferredLanguageOptions = makeActionCreator(
  OptionsConstants.SET_PREFERRED_LANGUAGE_OPTIONS,
  'preferredLanguageOptions'
)

export const setIndustryOptions = makeActionCreator(OptionsConstants.SET_INDUSTRY_OPTIONS, 'industryOptions')
export const setOccupationOptions = makeActionCreator(OptionsConstants.SET_OCCUPATION_OPTIONS, 'occupationOptions')

export const setImagingUltrasoundFindingsOptions = makeActionCreator(
  OptionsConstants.SET_IMAGING_ULTRASOUND_FINDINGS_OPTIONS,
  'findingsOptions'
)
export const setImagingUltrasoundTypeOptions = makeActionCreator(
  OptionsConstants.SET_IMAGING_ULTRASOUND_TYPE_OPTIONS,
  'typeOptions'
)
export const setMechanicalCprTypeOptions = makeActionCreator(
  OptionsConstants.SET_MECHANICAL_CPR_TYPE_OPTIONS,
  'mechanicalCprTypeOptions'
)
export const setFirstOnSceneOptions = makeActionCreator(
  OptionsConstants.SET_FIRST_ON_SCENE_OPTIONS,
  'firstOnSceneOptions'
)
export const setLevelCarePerProtocolOptions = makeActionCreator(
  OptionsConstants.SET_LEVEL_CARE_PER_PROTOCOL_OPTIONS,
  'levelCarePerProtocolOptions'
)
export const setPrOtherAgenciesOptions = makeActionCreator(
  OptionsConstants.SET_PR_OTHER_AGENCIES_OPTIONS,
  'prOtherAgenciesOptions'
)
export const setTransferOfCareOptions = makeActionCreator(
  OptionsConstants.SET_TRANSFER_OF_CARE_OPTIONS,
  'transferOfCareOptions'
)
export const setPrDisasterOptions = makeActionCreator(OptionsConstants.SET_PR_DISASTER_OPTIONS, 'prDisasterOptions')

export const setPrPtMovedViaOptions = makeActionCreator(
  OptionsConstants.SET_PR_PT_MOVED_VIA_OPTIONS,
  'prPtMovedViaOptions'
)
export const setPrPtPositionOptions = makeActionCreator(
  OptionsConstants.SET_PR_PT_POSITION_OPTIONS,
  'prPtPositionOptions'
)
export const setPrPtMovedFromOptions = makeActionCreator(
  OptionsConstants.SET_PR_PT_MOVED_FROM_OPTIONS,
  'prPtMovedFromOptions'
)
export const setPrTransportAssessOptions = makeActionCreator(
  OptionsConstants.SET_PR_TRANSPORT_ASSESS_OPTIONS,
  'prTransportAssessOptions'
)
export const setPrDispoInstructionsOptions = makeActionCreator(
  OptionsConstants.SET_PR_DISPO_INSTRUCTIONS_OPTIONS,
  'prDispoInstructionsOptions'
)
export const setAirStatusOptions = makeActionCreator(OptionsConstants.SET_AIR_STATUS_OPTIONS, 'airStatusOptions')
export const setAirTypeOptions = makeActionCreator(OptionsConstants.SET_AIR_TYPE_OPTIONS, 'airTypeOptions')
export const setAirEttSizeUnitOptions = makeActionCreator(
  OptionsConstants.SET_AIR_ETT_SIZE_UNIT_OPTIONS,
  'airEttSizeUnitOptions'
)
export const setAirByOptions = makeActionCreator(OptionsConstants.SET_AIR_BY_OPTIONS, 'airByOptions')
export const setAirOutcomeOptions = makeActionCreator(OptionsConstants.SET_AIR_OUTCOME_OPTIONS, 'airOutcomeOptions')
export const setAirVerificationAssessOptions = makeActionCreator(
  OptionsConstants.SET_AIRWAY_VERIFICATION_ASSESS_OPTIONS,
  'prAirwayVerificationAssessOptions'
)
export const setAirAssessOptions = makeActionCreator(
  OptionsConstants.SET_AIRWAY_ASSESS_OPTIONS,
  'prAirwayAssessOptions'
)
export const setAirBroselowOptions = makeActionCreator(
  OptionsConstants.SET_AIRWAY_BROSELOW_OPTIONS,
  'airBroselowOptions'
)
export const setBreathSoundLeftOptions = makeActionCreator(
  OptionsConstants.SET_BREATH_SOUND_LEFT_OPTIONS,
  'breathSoundLeftOptions'
)
export const setBreathSoundRightOptions = makeActionCreator(
  OptionsConstants.SET_BREATH_SOUND_RIGHT_OPTIONS,
  'breathSoundRightOptions'
)
export const setRespEffortOptions = makeActionCreator(OptionsConstants.SET_RESP_EFFORT_OPTIONS, 'respEffortOptions')
export const setRespViaOptions = makeActionCreator(OptionsConstants.SET_RESP_VIA_OPTIONS, 'respViaOptions')
export const setRespPerformByOptions = makeActionCreator(
  OptionsConstants.SET_RESP_PERFORM_BY_OPTIONS,
  'respPerformByOptions'
)
export const setRespOutcomeOptions = makeActionCreator(OptionsConstants.SET_RESP_OUTCOME_OPTIONS, 'respOutcomeOptions')
export const setRespExamOptions = makeActionCreator(OptionsConstants.SET_RESP_EXAM_OPTIONS, 'respExamOptions')

export const setMotorOptions = makeActionCreator(OptionsConstants.SET_MOTOROPTIONS, 'motorOptions')
export const setSensoryOptions = makeActionCreator(OptionsConstants.SET_SENSORYOPTIONS, 'sensoryOptions')
export const setPupilsSizeOptions = makeActionCreator(OptionsConstants.SET_PUPILSSIZEOPTIONS, 'pupilsSizeOptions')
export const setPupilsReactOptions = makeActionCreator(OptionsConstants.SET_PUPILSREACTOPTIONS, 'pupilsReactOptions')
export const setHeadConciousnessOptions = makeActionCreator(
  OptionsConstants.SET_HEADCONCIOUSNESSOPTIONS,
  'headConciousnessOptions'
)
export const setThromScreenOptions = makeActionCreator(OptionsConstants.SET_THROMSCREENOPTIONS, 'thromScreenOptions')
export const setStrokeScaleNeuroOptions = makeActionCreator(
  OptionsConstants.SET_STROKESCALENEUROOPTIONS,
  'strokeScaleNeuroOptions'
)
export const setStrokeCvaSymptomsResolvedOptions = makeActionCreator(
  OptionsConstants.SET_STROKECVASYMPTOMSRESOLVEDOPTIONS,
  'strokeCvaSymptomsResolvedOptions'
)
export const setHeadLossConsOptions = makeActionCreator(OptionsConstants.SET_HEADLOSSCONSOPTIONS, 'headLossConsOptions')

export const setPtsAirwayOptions = makeActionCreator(OptionsConstants.SET_PTS_AIR_OPTIONS, 'ptsAirwayOptions')
export const setPtsBpOptions = makeActionCreator(OptionsConstants.SET_PTS_BP_OPTIONS, 'ptsBpOptions')
export const setPtsCnsOptions = makeActionCreator(OptionsConstants.SET_PTS_CNS_OPTIONS, 'ptsCnsOptions')
export const setPtsSizeOptions = makeActionCreator(OptionsConstants.SET_PTS_SIZE_OPTIONS, 'ptsSizeOptions')
export const setPtsSkelOptions = makeActionCreator(OptionsConstants.SET_PTS_SKEL_OPTIONS, 'ptsSkelOptions')
export const setPtsWoundOptions = makeActionCreator(OptionsConstants.SET_PTS_WOUND_OPTIONS, 'ptsWoundOptions')

export const setRtsSysBpOptions = makeActionCreator(OptionsConstants.SET_RTS_SYS_BP_OPTIONS, 'rtsSysBpOptions')
export const setRtsRespRateOptions = makeActionCreator(OptionsConstants.SET_RTS_RESP_RATE_OPTIONS, 'rtsRespRateOptions')

export const setWasPatientImmboilizedPerformedByOptions = makeActionCreator(
  OptionsConstants.SET_PATIENT_WAS_IMMOBILIZED_PERFORMED_BY,
  'wasPatientImmobilizedPerformedByOptions'
)
export const setWasPatientImmboilizedOutcomeOptions = makeActionCreator(
  OptionsConstants.SET_PATIENT_WAS_IMMOBILIZED_OUTCOME,
  'wasPatientImmobilizedOutcomeOptions'
)

export const setGCSQualifierOptions = makeActionCreator(OptionsConstants.SET_GCS_QUALIFIER, 'gcsQualifierOptions')
export const setGCSEyeResponseOptions = makeActionCreator(
  OptionsConstants.SET_GCS_EYE_RESPONSE,
  'gcsEyeResponseOptions'
)
export const setGCSVerbalResponseOptions = makeActionCreator(
  OptionsConstants.SET_GCS_VERBAL_RESPONSE,
  'gcsVerbalResponseOptions'
)
export const setGCSMotorResponseOptions = makeActionCreator(
  OptionsConstants.SET_GCS_MOTOR_RESPONSE,
  'gcsMotorResponseOptions'
)

export const setPulsesOptions = makeActionCreator(OptionsConstants.SET_PULSES_OPTIONS, 'pulsesOptions')
export const setPrCvAssessOptions = makeActionCreator(OptionsConstants.SET_PR_CV_ASSESS_OPTIONS, 'prCvAssessOptions')
export const setCvTempMethodOptions = makeActionCreator(
  OptionsConstants.SET_CV_TEMP_METHOD_OPTIONS,
  'cvTempMethodOptions'
)
export const setCvJvdOptions = makeActionCreator(OptionsConstants.SET_CV_JVD_OPTIONS, 'cvJvdOptions')
export const setCvCapRefillOptions = makeActionCreator(OptionsConstants.SET_CV_CAP_REFILL_OPTIONS, 'cvCapRefillOptions')
export const setCvEdemaOptions = makeActionCreator(OptionsConstants.SET_CV_EDEMA_OPTIONS, 'cvEdemaOptions')
export const setCvArtOptions = makeActionCreator(OptionsConstants.SET_CV_ART_OPTIONS, 'cvArtOptions')
export const setCvSwanOptions = makeActionCreator(OptionsConstants.SET_CV_SWAN_OPTIONS, 'cvSwanOptions')
export const setPmTypeOptions = makeActionCreator(OptionsConstants.SET_PM_TYPE_OPTIONS, 'pmTypeOptions')
export const setNeuroStrokeScoreScaleOptions = makeActionCreator(
  OptionsConstants.SET_NEURO_STROKE_SCALE_SCORE_OPTIONS,
  'strokeScaleScoreOptions'
)
export const setStrokeScaleConfigOptions = makeActionCreator(
  OptionsConstants.SET_STROKE_SCALE_CONFIG_OPTIONS,
  'strokeScaleConfigOptions'
)
export const setNeuroCustomStrokeScoreScaleOptions = makeActionCreator(
  OptionsConstants.SET_NEURO_CUSTOM_STROKE_SCALE_SCORE_OPTIONS,
  'customStrokeScaleScoreOptions'
)
export const setVitalsCustomStrokeScoreScaleOptions = makeActionCreator(
  OptionsConstants.SET_VITALS_CUSTOM_STROKE_SCALE_SCORE_OPTIONS,
  'customStrokeScaleScoreOptions'
)
export const setJointCommissionTimeOutOptions = makeActionCreator(
  OptionsConstants.SET_JOINT_COMMISSION_TIMEOUT_OPTIONS,
  'jointCommissionTimeOutOptions'
)
export const setLabsConfigOptions = makeActionCreator(OptionsConstants.SET_LABS_CONFIG_OPTIONS, 'labsConfigOptions')
export const setAbgAccessOptions = makeActionCreator(OptionsConstants.SET_ABG_ACCESS_OPTIONS, 'abgAccessOptions')
export const setPnProcedureOptions = makeActionCreator(
  OptionsConstants.SET_PN_PROCEDURE_OPTIONS,
  'pertinentNegativeProcedureOptions'
)
export const setExposureEquipmentOptions = makeActionCreator(
  OptionsConstants.SET_EXPOSURE_EQUIPMENT_OPTIONS,
  'exposureEquipmentOptions'
)
export const setExposureTypeOptions = makeActionCreator(
  OptionsConstants.SET_EXPOSURE_TYPE_OPTIONS,
  'exposureTypeOptions'
)
export const setExposedToOptions = makeActionCreator(OptionsConstants.SET_EXPOSED_TO_OPTIONS, 'exposedToOptions')
export const setExposureCrewOptions = makeActionCreator(OptionsConstants.SET_EXPOSURE_CREW, 'exposureCrewOptions')
export const setSuspectedExposureOptions = makeActionCreator(
  OptionsConstants.SET_SUSPECTED_EXPOSURE,
  'suspectedExposureOptions'
)
export const setPhysicianTypeOptions = makeActionCreator(
  OptionsConstants.SET_PHYSICIAN_TYPE_OPTIONS,
  'physicianTypeOptions'
)

export const setAirbagDeployedOptions = makeActionCreator(
  OptionsConstants.SET_AIRBAG_DEPLOYED_OPTIONS,
  'airbagDeployedOptions'
)
export const setVehicleImpactSiteOptions = makeActionCreator(
  OptionsConstants.SET_VEHICLE_IMPACT_SITE_OPTIONS,
  'vehicleImpactSiteOptions'
)
export const setLocationOfPatientInVehicleOptions = makeActionCreator(
  OptionsConstants.SET_LOCATION_OF_PATIENT_IN_VEHICLE_OPTIONS,
  'locationOfPatientInVehicleOptions'
)
export const setExtricationRequiredOptions = makeActionCreator(
  OptionsConstants.SET_EXTRICATION_REQUIRED_OPTIONS,
  'extricationRequiredOptions'
)
export const setImmunizationStatusOptions = makeActionCreator(
  OptionsConstants.SET_IMMUNIZATION_STATUS_OPTIONS,
  'immunizationStatusOptions'
)
export const setImmunizationTypeOptions = makeActionCreator(
  OptionsConstants.SET_IMMUNIZATION_TYPE_OPTIONS,
  'immunizationTypeOptions'
)
export const setImmunizationYearOptions = makeActionCreator(
  OptionsConstants.SET_IMMUNIZATION_YEAR_OPTIONS,
  'immunizationYearOptions'
)

export const setPatientCountyOptions = makeActionCreator(
  OptionsConstants.SET_PATIENT_COUNTY_OPTIONS,
  'patientCountyOptions'
)

export const setResidenceOptions = makeActionCreator(OptionsConstants.SET_RESIDENCE_OPTIONS, 'residenceOptions')

export const setAltHomeResidenceOptions = makeActionCreator(
  OptionsConstants.SET_ALT_HOME_RESIDENCE_OPTIONS,
  'altHomeResidenceOptions'
)

export const setEmployerCountyOptions = makeActionCreator(
  OptionsConstants.SET_EMPLOYER_COUNTY_OPTIONS,
  'employerCountyOptions'
)

export const setPickUpAndDestinationCountyOptions = makeActionCreator(
  OptionsConstants.SET_PICK_UP_AND_DESTINATION_COUNTY_OPTIONS,
  'pickUpAndDestinationCountyOptions'
)
export const setCommonAddressesOptions = makeActionCreator(
  OptionsConstants.SET_COMMON_ADDRESSES_OPTIONS,
  'commonAddressesOptions'
)
export const setRulesOptions = makeActionCreator(
  OptionsConstants.SET_RULES_OPTIONS,
  'standardRules',
  'indexedStandardRules',
  'xsdRules',
  'indexedXsdRules',
  'nationalRules',
  'indexedNationalRules',
  'serviceRules',
  'indexedServiceRules'
)

export const setStateRules = makeActionCreator(OptionsConstants.SET_STATE_RULES, 'stateRules', 'indexedStateRules')

export const setSystemOptions = makeActionCreator(OptionsConstants.SET_SYSTEM_OPTIONS, 'systemOptions')
export const setSymptomsOptions = makeActionCreator(OptionsConstants.SET_SYMPTOMS_OPTIONS, 'symptomsOptions')
export const setImpressionsOptions = makeActionCreator(OptionsConstants.SET_IMPRESSIONS_OPTIONS, 'impressionsOptions')
export const setAnatomicLocationOptions = makeActionCreator(
  OptionsConstants.SET_ANATOMIC_LOCATION_OPTIONS,
  'anatomicLocationOptions'
)
export const setFinalPatientAcuityOptions = makeActionCreator(
  OptionsConstants.SET_FINAL_PATIENT_ACUITY_OPTIONS,
  'finalPatientAcuityOptions'
)
export const setConditionAtDestOptions = makeActionCreator(
  OptionsConstants.SET_CONDITION_AT_DEST_OPTIONS,
  'conditionAtDestinationOptions'
)

export const setIsPatientPregnantOptions = makeActionCreator(
  OptionsConstants.SET_IS_PATIENT_PREGNANT_OPTIONS,
  'isPatientPregnantOptions'
)

export const setBloodyShowOptions = makeActionCreator(OptionsConstants.SET_BLOODY_SHOW_OPTIONS, 'bloodyShowOptions')

export const setDynamicRangeOptions = makeActionCreator(
  OptionsConstants.SET_DYNAMIC_RANGE_OPTIONS,
  'path',
  'dynamicRangeOptions'
)

export const setPrenatalCareOptions = makeActionCreator(
  OptionsConstants.SET_PRENATAL_CARE_OPTIONS,
  'prenatalCareOptions'
)

export const setMembranesOptions = makeActionCreator(
  OptionsConstants.SET_MEMBRANES_AMNIOTIC_FLUID_OPTIONS,
  'membranesOptions'
)

export const setMaternalMedicationsAdministeredOptions = makeActionCreator(
  OptionsConstants.SET_MATERNAL_MEDICATIONS_ADMINISTERED_OPTIONS,
  'maternalMedicationsAdministeredOptions'
)
export const setBurnTypeOptions = makeActionCreator(OptionsConstants.SET_BURN_TYPE_OPTIONS, 'burnTypeOptions')

export const setBodySurveyExamValueOptions = makeActionCreator(
  OptionsConstants.SET_BODY_SURVEY_EXAM_OPTIONS,
  'examValueOptions'
)

export const setBodySurveySelectedExamValueOptions = makeActionCreator(
  OptionsConstants.SET_BODY_SURVEY_SELECTED_EXAM_OPTIONS,
  'selectedExamOptions'
)
export const setBodySurveyBodyPartsOptions = makeActionCreator(
  OptionsConstants.SET_BODY_SURVEY_BODY_PARTS_OPTIONS,
  'bodyPartsOptions'
)
export const setBodySurveyGeneralExtremitiesOptions = makeActionCreator(
  OptionsConstants.SET_BODY_SURVEY_GENERAL_EXTREMITIES_OPTIONS,
  'generalExtremitiesOptions'
)
export const setBodySurveySkinOptions = makeActionCreator(OptionsConstants.SET_BODY_SURVEY_SKIN_OPTIONS, 'skinOptions')
export const setBodySurveyNeuroOption = makeActionCreator(
  OptionsConstants.SET_BODY_SURVEY_NEURO_OPTIONS,
  'neuroExamOptions'
)
export const setBodySurveyCardiacOptions = makeActionCreator(
  OptionsConstants.SET_BODY_SURVEY_CARDIAC_OPTIONS,
  'cardiacExamOptions'
)
export const setBodySurveyMentalOptions = makeActionCreator(
  OptionsConstants.SET_BODY_SURVEY_MENTAL_OPTIONS,
  'mentalExamOptions'
)
export const setAssessmentDefaultOption = makeActionCreator(
  OptionsConstants.SET_ASSESSMENT_DEFAULT_OPTIONS,
  'assessmentDefaultOptions'
)
export const setAlsAssessmentOptions = makeActionCreator(
  OptionsConstants.SET_ALS_ASSESSMENT_OPTIONS,
  'alsAssessmentOptions'
)
export const setNeuroGazeOptions = makeActionCreator(OptionsConstants.SET_NEURO_GAZE_OPTIONS, 'neuroGazeOptions')
export const setNeuroSpeechOptions = makeActionCreator(OptionsConstants.SET_NEURO_SPEECH_OPTIONS, 'neuroSpeechOptions')
export const setNeuroLimbOptions = makeActionCreator(OptionsConstants.SET_NEURO_LIMB_OPTIONS, 'neuroLimbOptions')
export const setNeuroFacialOptions = makeActionCreator(OptionsConstants.SET_NEURO_FACIAL_OPTIONS, 'neuroFacialOptions')
export const setNeuroMotorOptions = makeActionCreator(OptionsConstants.SET_NEURO_MOTOR_OPTIONS, 'neuroMotorOptions')
export const setAssessmentActionOptions = makeActionCreator(
  OptionsConstants.SET_ASSESSMENT_ACTION_OPTIONS,
  'actionOptions'
)
export const setSepsisIndicatorsOptions = makeActionCreator(
  OptionsConstants.SET_SEPSIS_INDICATORS_OPTIONS,
  'sepsisIndicatorsOptions'
)
export const setCustomActionFieldOptions = makeActionCreator(
  OptionsConstants.SET_CUSTOM_ACTION_FIELDS_OPTIONS,
  'customActionFieldsOptions'
)
export const setCustomActionFieldAnswersOptions = makeActionCreator(
  OptionsConstants.SET_CUSTOM_ACTION_FIELDS_ANSWERS_OPTIONS,
  'customActionFieldsAnswersOptions'
)
export const setAllPNNVOptions = makeActionCreator(OptionsConstants.SET_ALL_PNNV_OPTIONS, 'allPNNVOptions')
export const setOtherAgencyNameOptions = makeActionCreator(
  OptionsConstants.SET_OTHER_AGENCY_NAME_OPTIONS,
  'otherAgencyNameOptions'
)
export const setOtherAgencyTypeOptions = makeActionCreator(
  OptionsConstants.SET_OTHER_AGENCY_TYPE_OPTIONS,
  'otherAgencyTypeOptions'
)
export const setReasonsForFailureOptions = makeActionCreator(
  OptionsConstants.SET_REASONS_FOR_FAILURE_OPTIONS,
  'reasonsForFailureOptions'
)
export const setCallTypeOptions = makeActionCreator(OptionsConstants.SET_CALL_TYPE_OPTIONS, 'callTypeOptions')
export const setNemsisCustomStateDataOptions = makeActionCreator(
  OptionsConstants.SET_NEMSIS_CUSTOM_OPTIONS,
  'customDataWithState'
)

export const setNemsisCustomConfigGroupOptions = makeActionCreator(
  OptionsConstants.SET_NEMSIS_CUSTOM_CONFIG_GROUPS,
  'customConfigGroupOptions'
)

export const setHideNemsisCustomOption = makeActionCreator(
  OptionsConstants.SET_HIDE_NEMSIS_CUSTOM_OPTION,
  'hideNemsisCustomOption'
)
export const setRulesUtilsModule = makeActionCreator(OptionsConstants.SET_RULES_UTILS_MODULE, 'rulesUtilsModule')

export const setPtVerifiedOptions = makeActionCreator(
  OptionsConstants.SET_PT_ID_VERIFIED_OPTIONS,
  'ptIdVerifiedOptions'
)
export const setClinicalIndicatorOptions = makeActionCreator(
  OptionsConstants.SET_CLINICAL_INDICATOR_OPTIONS,
  'clinicalIndicatorOptions'
)
export const setCrossMatchedOptions = makeActionCreator(
  OptionsConstants.SET_CROSS_MATCHED_OPTIONS,
  'crossMatchedOptions'
)
export const setTransfusionConsentOptions = makeActionCreator(
  OptionsConstants.SET_TRANSFUSION_CONSENT_OPTIONS,
  'transfusionConsentOptions'
)
export const setBloodProductTypeOptions = makeActionCreator(
  OptionsConstants.SET_BLOOD_PRODUCT_TYPE_OPTIONS,
  'bloodProductTypeOptions'
)
export const setBloodProductOptions = makeActionCreator(
  OptionsConstants.SET_BLOOD_PRODUCT_OPTIONS,
  'bloodProductOptions'
)
export const setBloodProductRouteOptions = makeActionCreator(
  OptionsConstants.SET_BLOOD_PRODUCT_ROUTE_OPTIONS,
  'bloodProductRouteOptions'
)
export const setTransfusionOrderOptions = makeActionCreator(
  OptionsConstants.SET_TRANSFUSION_ORDER_OPTIONS,
  'transfusionOrderOptions'
)
export const setImpliedEmergentConsentReasonOptions = makeActionCreator(
  OptionsConstants.SET_IMPLIED_EMERGENT_CONSENT_REASON_OPTIONS,
  'impliedEmergentConsentReasonOptions'
)

export const setVadTypeOptions = makeActionCreator(OptionsConstants.SET_VAD_TYPE_OPTIONS, 'vadTypeOptions')
export const setVadAlarmsOptions = makeActionCreator(OptionsConstants.SET_VAD_ALARMS_OPTIONS, 'vadAlarmsOptions')
export const setVadSiteAssessmentOptions = makeActionCreator(
  OptionsConstants.SET_VAD_SITE_ASSESSMENT_OPTIONS,
  'vadSiteAssessmentOptions'
)
export const setVadCatheterSizeOptions = makeActionCreator(
  OptionsConstants.SET_VAD_CATHETER_SIZE_OPTIONS,
  'vadCatheterSizeOptions'
)
export const setVadPlacementConfirmedByOptions = makeActionCreator(
  OptionsConstants.SET_VAD_PLACEMENT_CONFIRMED_BY_OPTIONS,
  'vadPlacementConfirmedByOptions'
)
export const setVadInsertLocationOptions = makeActionCreator(
  OptionsConstants.SET_VAD_INSERT_LOCATION_OPTIONS,
  'vadInsertLocationOptions'
)
export const setVadMotorCurrentWaveformCharacteristicsOptions = makeActionCreator(
  OptionsConstants.SET_VAD_MOTOR_CURRENT_WAVEFORM_CHARACTERISTICS_OPTIONS,
  'vadMotorCurrentWaveformCharacteristicsOptions'
)
export const setVadPlacementSignalWaveformCharacteristicsOptions = makeActionCreator(
  OptionsConstants.SET_VAD_PLACEMENT_SIGNAL_WAVE_FORM_CHARACTERISTICS_OPTIONS,
  'vadPlacementSignalWaveformCharacteristicsOptions'
)
export const setVadPlacementLocationOptions = makeActionCreator(
  OptionsConstants.SET_VAD_PLACEMENT_LOCATION_OPTIONS,
  'vadPlacementLocationOptions'
)
export const setVadPowerTypeOptions = makeActionCreator(
  OptionsConstants.SET_VAD_POWER_TYPE_OPTIONS,
  'vadPowerTypeOptions'
)
export const setVadBackupOptions = makeActionCreator(
  OptionsConstants.SET_VAD_BACKUP_OPTIONS_OPTIONS,
  'vadBackupOptions'
)
export const setVadBatteryStatusOptions = makeActionCreator(
  OptionsConstants.SET_VAD_BATTERY_STATUS_OPTIONS,
  'vadBatteryStatusOptions'
)
export const setVadFlowTypeOptions = makeActionCreator(OptionsConstants.SET_VAD_FLOW_TYPE_OPTIONS, 'vadFlowTypeOptions')
export const setVadIndicationOptions = makeActionCreator(
  OptionsConstants.SET_VAD_INDICATION_OPTIONS,
  'vadIndicationOptions'
)
export const setVadMakeModelOptions = makeActionCreator(
  OptionsConstants.SET_VAD_MAKE_MODEL_OPTIONS,
  'vadMakeModelOptions'
)
export const setVadMakeModelImpellaOptions = makeActionCreator(
  OptionsConstants.SET_VAD_MAKE_MODEL_IMPELLA_OPTIONS,
  'vadMakeModelImpellaOptions'
)
export const setYesNoOptions = makeActionCreator(OptionsConstants.SET_YES_NO_OPTIONS, 'yesNoOptions')

export const setCriticalCareSiteOptions = makeActionCreator(
  OptionsConstants.SET_CRITICAL_CARE_SITE_OPTIONS_DOC,
  'siteOptions'
)
export const setIabpAugmentationOptions = makeActionCreator(
  OptionsConstants.SET_IABP_AUGMENTATION_OPTIONS_DOC,
  'iabpAugmentationOptions'
)
export const setTaskOptions = makeActionCreator(OptionsConstants.SET_TASK_OPTIONS_DOC, 'taskOptions')
export const setIabpFrequencyOptions = makeActionCreator(
  OptionsConstants.SET_IABP_FREQUENCY_OPTIONS_DOC,
  'iabpFrequencyOptions'
)
export const setInsertionSiteOptions = makeActionCreator(
  OptionsConstants.SET_INSERTION_SITE_OPTIONS_DOC,
  'insertionSiteOptions'
)
export const setTriggerUtilizedOptions = makeActionCreator(
  OptionsConstants.SET_TRIGGER_UTILIZED_OPTIONS_DOC,
  'triggerUtilizedOptions'
)
export const setCriticalCareActionOptions = makeActionCreator(
  OptionsConstants.SET_CRITICAL_CARE_ACTION_OPTIONS_DOC,
  'actionOptions'
)
export const setSlowGasLeakOptions = makeActionCreator(
  OptionsConstants.SET_SLOW_GAS_LEAK_OPTIONS_DOC,
  'slowGasLeakOptions'
)
export const setAutoManualOptions = makeActionCreator(OptionsConstants.SET_AUTO_MANUAL_OPTIONS_DOC, 'autoManualOptions')

export const setSctProcsOptions = makeActionCreator(OptionsConstants.SET_SCT_PROCS_OPTIONS, 'sctProcsOptions')

export const setSctMedsOptions = makeActionCreator(OptionsConstants.SET_SCT_MEDS_OPTIONS, 'sctMedsOptions')

export const setCustomFluidsOptions = makeActionCreator(
  OptionsConstants.SET_CUSTOM_FLUIDS_OPTIONS,
  'customFluidsOptions'
)

export const setApgarAppearanceOptions = makeActionCreator(
  OptionsConstants.SET_APGAR_APPEARANCE_OPTIONS,
  'apgarAppearanceOptions'
)
export const setApgarPulseOptions = makeActionCreator(OptionsConstants.SET_APGAR_PULSE_OPTIONS, 'apgarPulseOptions')
export const setApgarGrimaceOptions = makeActionCreator(
  OptionsConstants.SET_APGAR_GRIMACE_OPTIONS,
  'apgarGrimaceOptions'
)
export const setApgarActivityOptions = makeActionCreator(
  OptionsConstants.SET_APGAR_ACTIVITY_OPTIONS,
  'apgarActivityOptions'
)
export const setApgarRespirationOptions = makeActionCreator(
  OptionsConstants.SET_APGAR_RESPIRATION_OPTIONS,
  'apgarRespirationOptions'
)

export const setTeamOptions = makeActionCreator(OptionsConstants.SET_TEAM_OPTIONS, 'teamOptions')
export const setTeamCareOnlyOptions = makeActionCreator(
  OptionsConstants.SET_TEAM_CARE_ONLY_OPTIONS,
  'teamCareOnlyOptions'
)
export const setEquipmentOptions = makeActionCreator(OptionsConstants.SET_EQUIPMENT_OPTIONS, 'equipmentOptions')
export const setProviderRolesOptions = makeActionCreator(
  OptionsConstants.SET_PROVIDER_ROLES_OPTIONS,
  'providerRolesOptions'
)
export const setFlightPlanOptions = makeActionCreator(OptionsConstants.SET_FLIGHT_PLAN_OPTIONS, 'flightPlanOptions')
export const setAdministeredByAnotherUnitOptions = makeActionCreator(
  OptionsConstants.SET_ADMINISTERED_BY_OTHER_UNIT_OPTIONS,
  'administeredByAnotherUnitOptions'
)
export const setDtWitnessedPNNVOptions = makeActionCreator(
  OptionsConstants.SET_DT_WITNESSED_PNNV_OPTIONS,
  'dtWitnessedPNNVOptions'
)
export const setSpecialReportData = makeActionCreator(OptionsConstants.SET_SPECIAL_REPORT_DATA, 'specialReportData')
export const setSpecialReportCategories = makeActionCreator(
  OptionsConstants.SET_SPECIAL_REPORT_CATEGORIES,
  'categories'
)
export const setSpecialReportSubCategories = makeActionCreator(
  OptionsConstants.SET_SPECIAL_REPORT_SUB_CATEGORIES,
  'subCategories'
)
export const setFillablePDFMetadata = makeActionCreator(OptionsConstants.SET_FILLABLE_PDF_METADATA, 'metadata')
export const setFillablePDFBindings = makeActionCreator(OptionsConstants.SET_FILLABLE_PDF_BINDINGS, 'bindings')
export const setPulsaraDateRangeOptions = makeActionCreator(
  OptionsConstants.SET_PULSARA_DATE_RANGE_OPTIONS,
  'pulsaraDateRangeOptions'
)
